module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "month-picker"
  }, _vm._l((_vm.items), function(item, key) {
    return _c('div', {
      staticClass: "month-item",
      class: {
        selected: _vm.value == key
      },
      on: {
        "click": function($event) {
          _vm.select(key)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-51992485!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./source/Calendar/MonthPicker.vue
// module id = 159
// module chunks = 1 3 4